import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { salvarToken } from "../utils/auth";

const API = process.env.REACT_APP_API_URL || "http://localhost:3001";

export default function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [manterConectado, setManterConectado] = useState(true);
  const [loading, setLoading] = useState(false);

  async function handleLogin(e) {
    e.preventDefault();

    if (!email || !password) {
      alert("Preencha email e senha");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(`${API}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          password,
          manterConectado,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.error || "Erro no login");
        return;
      }

      // salva token corretamente
      salvarToken(data.token, manterConectado);

      navigate("/dashboard");
    } catch (err) {
      alert("Erro ao conectar com servidor");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={styles.page}>
      <div style={styles.glow1}></div>
      <div style={styles.glow2}></div>

      <div style={styles.card}>
        <div style={styles.logoArea}>
          <img src="/gestor-one-192.png" alt="Gestor One" style={styles.logo} />

          <h1 style={styles.title}>Gestor One</h1>

          <p style={styles.subtitle}>
            Entre para acessar seu painel
          </p>
        </div>

        <form onSubmit={handleLogin} style={styles.form}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>E-mail</label>

            <input
              style={styles.input}
              placeholder="Digite seu e-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Senha</label>

            <div style={styles.passwordBox}>
              <input
                style={styles.passwordInput}
                type={mostrarSenha ? "text" : "password"}
                placeholder="Digite sua senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <button
                type="button"
                onClick={() => setMostrarSenha(!mostrarSenha)}
                style={styles.showButton}
              >
                {mostrarSenha ? "Ocultar" : "Mostrar"}
              </button>
            </div>
          </div>

          <div style={styles.options}>
            <label style={styles.checkboxLabel}>
              <input
                type="checkbox"
                checked={manterConectado}
                onChange={(e) =>
                  setManterConectado(e.target.checked)
                }
              />

              <span>Manter conectado</span>
            </label>

            <Link
              to="/esqueci-senha"
              style={styles.link}
            >
              Esqueceu a senha?
            </Link>
          </div>

          <button
            style={styles.button}
            type="submit"
            disabled={loading}
          >
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>

        <div style={styles.footer}>
          <span style={{ color: "#94a3b8" }}>
            Ainda não tem conta?
          </span>

          <Link
            to="/cadastro"
            style={styles.createAccount}
          >
            Criar conta
          </Link>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background:
      "linear-gradient(135deg, #020617 0%, #0f172a 50%, #111827 100%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
    position: "relative",
    overflow: "hidden",
    fontFamily:
      "Inter, Arial, sans-serif",
  },

  glow1: {
    position: "absolute",
    width: 300,
    height: 300,
    background: "#2563eb",
    borderRadius: "50%",
    filter: "blur(120px)",
    opacity: 0.25,
    top: -80,
    left: -80,
  },

  glow2: {
    position: "absolute",
    width: 300,
    height: 300,
    background: "#0ea5e9",
    borderRadius: "50%",
    filter: "blur(120px)",
    opacity: 0.2,
    bottom: -80,
    right: -80,
  },

  card: {
    width: "100%",
    maxWidth: 420,
    background: "rgba(15,23,42,0.92)",
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: 28,
    padding: 32,
    backdropFilter: "blur(20px)",
    boxShadow:
      "0 25px 60px rgba(0,0,0,0.45)",
    position: "relative",
    zIndex: 2,
  },

  logoArea: {
    textAlign: "center",
    marginBottom: 30,
  },

  logo: {
    width: 80,
    height: 80,
    borderRadius: 24,
    margin: "0 auto 18px auto",
    boxShadow:
      "0 15px 40px rgba(37,99,235,0.4)",
  },

  title: {
    color: "#fff",
    margin: 0,
    fontSize: 28,
    fontWeight: 800,
  },

  subtitle: {
    color: "#94a3b8",
    marginTop: 10,
    fontSize: 14,
  },

  form: {
    display: "flex",
    flexDirection: "column",
    gap: 18,
  },

  inputGroup: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },

  label: {
    color: "#cbd5e1",
    fontSize: 14,
    fontWeight: 600,
  },

  input: {
    height: 54,
    borderRadius: 16,
    border: "1px solid rgba(255,255,255,0.08)",
    background: "#1e293b",
    padding: "0 18px",
    color: "#fff",
    fontSize: 15,
    outline: "none",
  },

  passwordBox: {
    display: "flex",
    alignItems: "center",
    background: "#1e293b",
    borderRadius: 16,
    border: "1px solid rgba(255,255,255,0.08)",
    overflow: "hidden",
  },

  passwordInput: {
    flex: 1,
    height: 54,
    background: "transparent",
    border: "none",
    padding: "0 18px",
    color: "#fff",
    fontSize: 15,
    outline: "none",
  },

  showButton: {
    background: "transparent",
    border: "none",
    color: "#38bdf8",
    padding: "0 16px",
    cursor: "pointer",
    fontWeight: 600,
  },

  options: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: -4,
    flexWrap: "wrap",
    gap: 10,
  },

  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    color: "#cbd5e1",
    fontSize: 14,
  },

  link: {
    color: "#38bdf8",
    textDecoration: "none",
    fontSize: 14,
    fontWeight: 600,
  },

  button: {
    marginTop: 10,
    height: 56,
    borderRadius: 18,
    border: "none",
    background:
      "linear-gradient(135deg,#2563eb,#0284c7)",
    color: "#fff",
    fontSize: 16,
    fontWeight: 700,
    cursor: "pointer",
    transition: "0.2s",
    boxShadow:
      "0 15px 35px rgba(37,99,235,0.35)",
  },

  footer: {
    marginTop: 24,
    display: "flex",
    justifyContent: "center",
    gap: 8,
    fontSize: 14,
  },

  createAccount: {
    color: "#38bdf8",
    textDecoration: "none",
    fontWeight: 700,
  },
};
